/**
 * Shared class names for the compact hit job title (normalised title).
 * Actual styles live in hit-card.css to keep SRP HTML small.
 * Used by both HitCompactView (static SRP) and HitCompact (interactive).
 * Single compact layout for all screen sizes.
 */
export const COMPACT_TITLE_LINK_CLASS_MOBILE = 'hit-title-mobile';

export const COMPACT_TITLE_SUBTITLE_CLASS_MOBILE = 'hit-subtitle-mobile';
